import React, { useMemo } from 'react';
import { Language, Situation } from '../../services/api';
import { useLanguage } from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { fixSituationColors } from '../../utils/situationUtils';

interface SituationPanelProps {
  situation?: Situation;
  variant?: 'basic' | 'compact';
  title?: string;
  className?: string;
  onClick?: () => void
}

const getLanguage = (lang: string | null): Language => {
    switch (lang) {
      case 'es': return Language.SP;
      case 'ru': return Language.RU;
      case 'ro': return Language.RO;
      case 'pt': return Language.PR;
      default: return Language.EN;
    }
  };

const SituationPanel: React.FC<SituationPanelProps> = ({
  situation = null,
  variant = 'basic',
  title,
  onClick,
  className = ''
}) => {
  const [language] = useLanguage();
  const { t } = useTranslation();

  const situationHtml = useMemo(() => {
    const lang = getLanguage(language)
    const s = situation && situation[lang] ? situation[lang] : "<span></span>";

    return fixSituationColors(s)
  }, [language, situation])

  if (variant === 'basic') {
      return (
        <div onClick={onClick} className={`bg-blue-50 border border-blue-200 rounded-lg p-4 w-full text-center ${className} ${!!onClick ? "cursor-pointer" : ""}`}>
          <div className="text-gray-700 text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: situationHtml }}/>
        </div>
      );
    }

    if (variant === 'compact') {
      return (
        <div onClick={onClick} className={`bg-gray-50 rounded-xl p-4 border-2 border-gray-100 ${className} ${!!onClick ? "cursor-pointer" : ""}`}>
          <h4 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
            {title || t('game.theSituation')}
          </h4>
          <div className="text-gray-700 italic font-medium" dangerouslySetInnerHTML={{ __html: situationHtml }}/>
        </div>
      );
    }

    return null
};

export default SituationPanel;